'use client';
import React, { useState } from 'react';
import { Filter } from 'lucide-react';

interface Props {
  activeFilter: 'all' | 'editorial' | 'lookbook';
  onFilterChange: (filter: 'all' | 'editorial' | 'lookbook') => void;
}

const filters = [
  { id: 'all', label: 'All Posts' },
  { id: 'editorial', label: 'Editorial' },
  { id: 'lookbook', label: 'Lookbook' },
] as const;

export default function FeedFilters({ activeFilter, onFilterChange }: Props) {
  return (
    <div className="flex items-center gap-2 mb-6 flex-wrap">
      <div className="flex items-center gap-1 text-xs text-charcoal-500 mr-1">
        <Filter size={13} />
        <span style={{ fontFamily: "'Cinzel', serif" }}>Filter:</span>
      </div>
      {filters.map((f) => (
        <button key={f.id} onClick={() => onFilterChange(f.id)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-150 ${
            activeFilter === f.id
              ? 'bg-charcoal-900 text-white' :'bg-white border border-cream-300 text-charcoal-600 hover:bg-cream-200 hover:border-cream-400'
          }`}
          style={{ fontFamily: "'Cinzel', serif" }}>
          {f.label}
        </button>
      ))}
    </div>
  );
}